<agr-dialog class="irrigation-dialog" [data]="data" (cancel)="cancel()">
  <div class="flex flex--column">
    <app-irrigation-dialog-crop-field-selection
      [selectedCropFields]="selectedCropFields()"
      [readOnly]="isReadonlyMode()"
      (cropFieldDeselected)="deselectCropField($event)"
    />

    @if (!isFmsReadonlyMode()) {
      <app-irrigation-register-form
        [actionDate]="data.actionDate"
        [readOnly]="isReadonlyMode()"
        [showPastYearReadonlyTooltip]="isPastYearReadonlyMode()"
        (irrigationRegistered)="registerIrrigation($event)"
      />
    }

    @if (isFmsReadonlyMode()) {
      <div class="notification notification-info spacing--margin-bottom">
        <mat-icon>info</mat-icon>
        {{ fmsReadonlyMessageKey | translate }}
      </div>
    }

    <div class="spacing--margin-vertical">
      <mat-divider />
    </div>

    <app-irrigation-dialog-overview
      [cropFieldsWithIrrigations]="cropFieldsWithIrrigations()"
      [readOnly]="isReadonlyMode()"
      (irrigationDeleted)="deleteIrrigation($event)"
    />
  </div>

  @if (isLoading()) {
    <mat-spinner class="spinner" />
  }
</agr-dialog>
